export default {
  getDevice(state) {
    return state.device;
  },
  getDevices(state) {
    return state.devices;
  },
};
